__turbopack_context__.v({
  "searchDescription": "searchMessage-module-scss-module__fJpIPG__searchDescription",
  "searchErrors": "searchMessage-module-scss-module__fJpIPG__searchErrors",
});
